import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/file.png'


const _withScopeId = n => (_pushScopeId("data-v-75398172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"calc(100vh - 220px)"} }
const _hoisted_2 = { class: "cv-add" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "完善简历", -1))
const _hoisted_4 = {
  key: 0,
  class: "df"
}
const _hoisted_5 = { class: "left-info" }
const _hoisted_6 = {
  style: {"margin-bottom":"20px"},
  id: "basicU"
}
const _hoisted_7 = {
  style: {"margin-bottom":"20px"},
  id: "expectU"
}
const _hoisted_8 = {
  style: {"margin-bottom":"20px"},
  id: "workU"
}
const _hoisted_9 = {
  style: {"margin-bottom":"20px"},
  id: "projectU"
}
const _hoisted_10 = {
  style: {"margin-bottom":"20px"},
  id: "eduU"
}
const _hoisted_11 = { class: "right-info" }
const _hoisted_12 = { class: "post-hr" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("div", { class: "info-head-title" }, [
    /*#__PURE__*/_createTextVNode(" 导入简历"),
    /*#__PURE__*/_createElementVNode("span", null, "(一键更新在线简历)")
  ])
], -1))
const _hoisted_14 = { class: "import-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.请上传中文简历", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.仅支持doc、docx、pdf格式", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("一键导入")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "cv-file-name" }
const _hoisted_20 = { class: "cv-file-uploadtime" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("div", { class: "info-head-title" }, "简历目录")
], -1))
const _hoisted_22 = { class: "catalogue-info" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-jibenxinxi1" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-qiuzhiqiwang" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求职期望", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-gongzuojingli" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作经历", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-xiangmujingli" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目经历", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-jiaoyujingli" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "教育经历", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("投递简历")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicInfo = _resolveComponent("BasicInfo")!
  const _component_Expect = _resolveComponent("Expect")!
  const _component_WorkExperience = _resolveComponent("WorkExperience")!
  const _component_ProjectExperience = _resolveComponent("ProjectExperience")!
  const _component_EduExperience = _resolveComponent("EduExperience")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_ViewPdf = _resolveComponent("ViewPdf")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_load = _resolveDirective("load")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.isInit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_BasicInfo, {
                    ref: "basicInfo",
                    accountId: _ctx.accountId,
                    isBatch: true,
                    basicInfoForm: _ctx.basicInfoForm,
                    setBasicInfo: _ctx.setBasicInfo
                  }, null, 8, ["accountId", "basicInfoForm", "setBasicInfo"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Expect, {
                    ref: "expect",
                    isBatch: true,
                    accountId: _ctx.accountId,
                    expectForm: _ctx.expectForm,
                    detail: _ctx.detail
                  }, null, 8, ["accountId", "expectForm", "detail"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_WorkExperience, {
                    accountId: _ctx.accountId,
                    isBatch: true,
                    ref: "workExperience",
                    detailData: { formArr: _ctx.workExpList },
                    detail: _ctx.detail
                  }, null, 8, ["accountId", "detailData", "detail"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ProjectExperience, {
                    accountId: _ctx.accountId,
                    isBatch: true,
                    ref: "projectExperience",
                    detailData: { formArr: _ctx.projectExpList },
                    detail: _ctx.detail
                  }, null, 8, ["accountId", "detailData", "detail"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_EduExperience, {
                    accountId: _ctx.accountId,
                    isBatch: true,
                    ref: "eduExperience",
                    detailData: { formArr: _ctx.eduExpList },
                    detail: _ctx.detail
                  }, null, 8, ["accountId", "detailData", "detail"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_upload, {
                      ref: "resumeRef",
                      class: "upload-btn",
                      accept: ".pdf,.doc,.docx",
                      action: _ctx.action,
                      limit: 1,
                      "show-file-list": false,
                      "on-success": _ctx.handleSuccess,
                      "on-exceed": _ctx.handleExceed,
                      "on-remove": _ctx.handleRemove
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "import-btn",
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["action", "on-success", "on-exceed", "on-remove"]),
                    (_ctx.fileList.length > 0 && _ctx.fileUploadTime)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "cv-file-info",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toPdf && _ctx.toPdf(...args)))
                        }, [
                          _createVNode(_component_el_icon, {
                            onClick: _withModifiers(_ctx.handleRemove, ["stop"]),
                            class: "cv-delete-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_delete)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _hoisted_18,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.fileList[0].name), 1),
                            _createElementVNode("span", _hoisted_20, "上传时间：" + _toDisplayString(_ctx.$utils.dateFm(_ctx.fileUploadTime, "YYYY-MM-DD hh:mm")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_affix, { offset: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 0 }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeHash('basicU', 0)))
                        }, _hoisted_25, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 1 }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeHash('expectU', 1)))
                        }, _hoisted_28, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 2 }),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeHash('workU', 2)))
                        }, _hoisted_31, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 3 }),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeHash('projectU', 3)))
                        }, _hoisted_34, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 4 }),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeHash('eduU', 4)))
                        }, _hoisted_37, 2)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.route.query.postId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createVNode(_component_el_button, {
              class: "submit-btn",
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_load, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "查看附件",
      width: "1100px",
      top: "5vh",
      center: true,
      "destroy-on-close": true,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ViewPdf, {
          resumeUrl: _ctx.detail.resumeUrl
        }, null, 8, ["resumeUrl"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}